var path = '/app/components/modals/google-maps-modal.component.html';
var html = "<modal [header-title]=\"$ctrl.resolve.title\" (on-close)=\"$ctrl.dismiss()\"> <modal-body> <div id=\"map\" style=\"width:100%;height:400px\"></div> </modal-body> </modal>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;